import React, { useState } from 'react';

import styled, { keyframes } from 'styled-components';

import ArrowRightIcon from 'components/icons/arrow-right';

interface ITextExpanderProps {
  openText?: string;
  closedText?: string;
  defaultExpanded?: boolean;
}

const Wrapper = styled.div``;

const Heading = styled.p`
  cursor: pointer;
  display: flex;
  align-items: center;
`;

const fadeIn = keyframes`
from {
    opacity: 0
}
to {
    opacity: 1
}
`;

const Arrow = styled(ArrowRightIcon)<{ expanded: boolean }>`
  margin-left: 0.75rem;
  user-select: none;
  transform: ${props => (props.expanded ? 'rotate(90deg)' : 'rotate(0deg)')};
  transition: transform 0.2s ease;
  fill: ${Styles.color.black};
  height: 13px;
`;

const Body = styled.div`
  animation: ${fadeIn} 0.2s forwards;
`;

const TextExpander: React.FC<ITextExpanderProps> = ({
  openText,
  closedText,
  children,
  defaultExpanded = false,
}) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  const toggleExpanded = () => setIsExpanded(isCurrentlyExpanded => !isCurrentlyExpanded);

  return (
    <Wrapper>
      <Heading onClick={toggleExpanded}>
        {isExpanded ? openText : closedText}
        <Arrow expanded={isExpanded} />
      </Heading>
      {isExpanded && <Body>{children}</Body>}
    </Wrapper>
  );
};

export default TextExpander;
